import { createRoute, type AnyRoute } from '@tanstack/react-router';
import { ProofPage } from './pages/ProofPage';

type ProofSearchParams = { c?: number };

/** `c` is the criterion number the PR checklist link points at. */
const validateProofSearch = (search: Record<string, unknown>): ProofSearchParams => {
  const c = Number(search.c);
  return Number.isInteger(c) && c > 0 ? { c } : {};
};

export function createProofRoutes<TRootRoute extends AnyRoute>(rootRoute: TRootRoute) {
  const proofRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/proofs/$proofId',
    component: ProofPage,
    validateSearch: validateProofSearch,
  });
  return { proofRoute };
}
